<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DEFAULT component for rendering the Duty activity Start (first line in a block)              -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row dense class="DutyActivityStart_Default">
    <v-col cols="2">{{ time(dutyActivity.fromMinutesAfterMidnight) }}</v-col>
    <v-col v-if="!hasTrueChildren" cols="2">{{ time(dutyActivity.toMinutesAfterMidnight) }}</v-col>
    <v-col cols="8">{{ dutyActivity.longName }}&nbsp;{{ dutyActivity.note }}</v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';

export default {
  name: 'DutyActivityStartDefault',
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
